import React, { Component } from 'react';
import { connect } from 'react-redux'
import querystring from 'querystring';
import { receiveItems } from '../../actions/item'
import classnames from 'classnames';
import {Router} from 'react-router'

@connect(state => ({
    isLoadingPopupOpened: state.popup.isLoadingPopupOpened,
    loadingPopupMessage: state.popup.loadingPopupMessage,
}), dispatch => ({
}))
class LoadingPopup extends Component {
    render() {
        return (
            <div className="blog_layer" style={{position: 'fixed', top: '50%', marginTop: '-59px', display: this.props.isLoadingPopupOpened?'block':'none'}}>
                <div className="inner_blog_layer inner_blog_loading">
                    <span className="ico_blog ico_loading"/>
                    <p className="txt_loading">{this.props.loadingPopupMessage}</p>
                </div>
            </div>
        );
    }
}


export default LoadingPopup;
